module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("题目反馈")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "处理状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.queryParam.handleStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "handleStatus", $$v)
      },
      expression: "queryParam.handleStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PENDING"
    }
  }, [_vm._v("待处理")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PROCESSING"
    }
  }, [_vm._v("处理中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DONE"
    }
  }, [_vm._v("已处理")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "REJECTED"
    }
  }, [_vm._v("不成立")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "反馈类型"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择类型"
    },
    model: {
      value: (_vm.queryParam.feedbackType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "feedbackType", $$v)
      },
      expression: "queryParam.feedbackType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "STEM_ERROR"
    }
  }, [_vm._v("题干错误")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OPTION_ERROR"
    }
  }, [_vm._v("选项错误")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "AUDIO_ERROR"
    }
  }, [_vm._v("音频错误")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "IMAGE_ERROR"
    }
  }, [_vm._v("图片错误")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "ANSWER_ERROR"
    }
  }, [_vm._v("答案或解析错误")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DISPLAY_ERROR"
    }
  }, [_vm._v("展示异常")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OTHER"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "测评类型"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择测评类型"
    },
    model: {
      value: (_vm.queryParam.examType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "examType", $$v)
      },
      expression: "queryParam.examType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PLACEMENT"
    }
  }, [_vm._v("入门测")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE"
    }
  }, [_vm._v("阶段测")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场次ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "sessionId"
    },
    model: {
      value: (_vm.queryParam.sessionId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "sessionId", $$v)
      },
      expression: "queryParam.sessionId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题目编码"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "业务编码"
    },
    model: {
      value: (_vm.queryParam.questionCode),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "questionCode", $$v)
      },
      expression: "queryParam.questionCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "disabled": !_vm.selection.length,
      "loading": _vm.batchLoading
    },
    on: {
      "click": _vm.batchOffline
    }
  }, [_vm._v("批量下线")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/mex/feedback/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "题目反馈",
      "width": "760"
    },
    model: {
      value: (_vm.detailVisible),
      callback: function($$v) {
        _vm.detailVisible = $$v
      },
      expression: "detailVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "70vh",
      "overflow-y": "auto",
      "padding-right": "8px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "反馈ID"
    }
  }, [_vm._v(_vm._s(_vm.detail.id))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "提交时间"
    }
  }, [_vm._v(_vm._s(_vm.detail.gmtCreate))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "学员"
    }
  }, [_vm._v(_vm._s(_vm.detail.studentName) + " / uid " + _vm._s(_vm.detail.uid))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_vm._v(_vm._s(_vm.detail.contactPhone || '—'))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "场次"
    }
  }, [_vm._v(_vm._s(_vm.examLabel(_vm.detail.examType)) + " / " + _vm._s(_vm.detail.sessionId))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "题目"
    }
  }, [(_vm.detail.questionCode) ? _c('a', {
    staticClass: "mex-feedback-qcode",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.jumpToQuestion.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.detail.questionCode))]) : _c('span', [_vm._v("—")]), _vm._v("\n          · " + _vm._s(_vm.skillLabel(_vm.detail.skill)) + " · 第" + _vm._s(_vm.detail.seq) + "题\n        ")]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_vm._v(_vm._s(_vm.typeLabel(_vm.detail.feedbackType)))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "内容"
    }
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.detail.content))])]), _vm._v(" "), (_vm.images.length) ? _c('Form-item', {
    attrs: {
      "label": "截图"
    }
  }, _vm._l((_vm.images), function(src, idx) {
    return _c('img', {
      key: idx,
      staticClass: "mex-feedback-img",
      attrs: {
        "src": src
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "当前状态"
    }
  }, [_vm._v(_vm._s(_vm.statusLabel(_vm.detail.handleStatus)))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "处理方式"
    }
  }, [(_vm.canHandle) ? _c('Select', {
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "placeholder": "结单必选"
    },
    model: {
      value: (_vm.handleMethod),
      callback: function($$v) {
        _vm.handleMethod = $$v
      },
      expression: "handleMethod"
    }
  }, [_c('Option', {
    attrs: {
      "value": "FIX_CONTENT"
    }
  }, [_vm._v("已改正文/选项/答案")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "FIX_ASSET"
    }
  }, [_vm._v("已替换音频或图片")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OFFLINE"
    }
  }, [_vm._v("已下线题目")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "NO_ISSUE"
    }
  }, [_vm._v("题目无误")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "CONTACT"
    }
  }, [_vm._v("已联系学员/家长")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OTHER"
    }
  }, [_vm._v("其他")])], 1) : _c('span', [_vm._v(_vm._s(_vm.methodLabel(_vm.detail.handleMethod)))])], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "处理人"
    }
  }, [_vm._v(_vm._s(_vm.detail.handlerName || '—'))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "处理时间"
    }
  }, [_vm._v(_vm._s(_vm.detail.handledAt || '—'))]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "处理备注"
    }
  }, [(_vm.canHandle) ? _c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "结单必填，说明改了什么或为何不成立"
    },
    model: {
      value: (_vm.handleRemark),
      callback: function($$v) {
        _vm.handleRemark = $$v
      },
      expression: "handleRemark"
    }
  }) : _c('p', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.detail.handleRemark || '—'))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.detailVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), (_vm.canHandle) ? _c('Button', {
    on: {
      "click": function($event) {
        return _vm.handle('PROCESSING')
      }
    }
  }, [_vm._v("处理中")]) : _vm._e(), _vm._v(" "), (_vm.canHandle) ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handle('DONE')
      }
    }
  }, [_vm._v("已处理")]) : _vm._e(), _vm._v(" "), (_vm.canHandle) ? _c('Button', {
    on: {
      "click": function($event) {
        return _vm.handle('REJECTED')
      }
    }
  }, [_vm._v("不成立")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-189ed3e1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mex/MexFeedbackList.vue
// module id = 1671
// module chunks = 8